/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_TitleInputs */



/**
* | output |
* | --- |
* | "Metrics Settings" |
*
* @param {Options_Metrics_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_title = /** @type {((inputs?: Options_Metrics_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Metrics Settings")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metrics Settings")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metrics Settings")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Metrics Settings")
	if (locale === "es") return /** @type {LocalizedString} */ ("Metrics Settings")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Metrics Settings")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Metrics Settings")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Metrics Settings")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Metrics Settings")
	return /** @type {LocalizedString} */ ("Metrics Settings")
});